import React, { useState, useEffect, useRef } from 'react';
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

import '../../assets/css/test-tabs.css'
import { useAuthDataContext } from '../../__providers/AuthProvider';

function EachTab(props) {

    const auth = useAuthDataContext();

    const [value, setValue] = useState(0);

    const handleChange = (e, newValue) => {
        setValue(newValue);
        let changeCurrentQuestion = e.target.getAttribute('data-id');
        if (window.innerWidth <= 1024) {
            if (value == newValue) return;
            else props.tabValue(newValue, changeCurrentQuestion);
        }
        else props.tabValue(newValue, changeCurrentQuestion);
    };

    const tabRef = useRef(0);

    let styles = {
        'display': props.showTabs ? 'flex' : 'none'
    }

    useEffect(() => {
        if (props.switchTabs != null) {
            document.querySelectorAll(`[data-tab="${props.switchTabs}"]`)[0].click();
        }
    }, [props.switchTabs])

    let el = document.getElementsByClassName('Mui-selected')[0]
    let secondEl = document.getElementById('mobileComment');
    if (el) {
        document.getElementsByClassName('Mui-selected')[0].addEventListener('click', function () {
            if (secondEl) secondEl.click();
        });
    }


    return (

        <Tabs
            orientation="horizontal"
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="horizontal tabs example"
            id="testTabs"
            style={styles}
        >
            {props.data.map((each, i) =>
                <Tab ref={tabRef} data-id={each.id} data-tab={each.id} key={i} label={
                    <div className="pages">
                        <div className={[
                            each.type === 1 ? 'question-with-image' : each.type === 2 ? 'answers-with-image' : 'text-only',

                            props.answered[each.id] && Object.keys(props.answered[each.id]).length ? 'blue' : '',

                            props.isCorrect[each.id] != null && props.correctAnswers[each.id] != null
                                ? props.isCorrect[each.id] === true ? 'green' : 'red'
                                : ''

                        ].join(' ')}>
                            <p>
                                {each.number}
                            </p>
                            <p className="mini-tests">
                                {each.type === 1 ?
                                    <span key={i}>
                                        <img src={each.thumbnail + '?token=' + auth.user.token} alt="picture" />
                                    </span>
                                    :
                                    each.answers.map((answer, i) =>
                                        <span data-id={i} key={i}>
                                            {answer.thumbnail ?
                                                <img src={answer.thumbnail + '?token=' + auth.user.token} alt="picture" />
                                                :
                                                ''
                                            }
                                        </span>
                                    )}
                            </p>
                        </div>
                    </div>
                } />
            )}

        </Tabs>
    )
}

export default EachTab;